import React, { useState, useRef, useCallback } from 'react';
import Block from '../block';
import { SvgIcon } from './Common/SvgIcon';
import { useOutsideHandling } from '../Hooks/CustomHooks';

const ContentfulBlockSelectPetAge = (props) => {
     const { selectAgeTextTop, selectAges, ageSelected, placeholder, isPreview } = props;
     const [isSelect, setSelect] = useState(false);
     const selectRef = useRef(null);

     const toggleDropdown = useCallback(() => {
          setTimeout(() => {
               setSelect(!isSelect);
          }, 100);
     }, [isSelect]);

     const handleClickOutsideSelect = useCallback(() => {
          setSelect(false);
     }, []);
     useOutsideHandling(selectRef, handleClickOutsideSelect);

     return (
          <div className="select-ages">
               {selectAgeTextTop && (<div className="top-text"><p>{selectAgeTextTop}</p></div>)}
               <div className={`dropdown ${isSelect ? 'show' : ''}`} onClick={toggleDropdown} ref={selectRef}>
                    <button className="age-selected">
                         {isSelect ? (<span className="muted-text">{placeholder ? placeholder : 'Select one'}</span>) : (<span className="active-text" dangerouslySetInnerHTML={{ __html: ageSelected.fields ? ageSelected.fields.linkText : ageSelected.linkText }}></span>)}
                         <div className="dropdown-icon"></div>
                         <SvgIcon type={isSelect ? 'sort-up' : 'sort-down'} />
                    </button>
                    <ul className={`${isSelect ? 'show' : ''}`}>
                         {selectAges.map((block, i) => {
                              return (<li key={i}><Block tabIndex={isSelect ? 0 : -1} block={block} /></li>)
                         })}
                    </ul>
               </div>
          </div>
     );
}

export { ContentfulBlockSelectPetAge }
